import styled from 'styled-components';

import MotifProgressLoader from '@ey/motif-react-wrapper/ProgressLoader';

export default styled(MotifProgressLoader)`
	margin: 0;
	&.no-background {
		background: transparent;
	}
`;
